export enum ViewingStatus {
  AWAITING_CONFIRMATION = "awaiting_confirmation",
  COMPLETED = "completed",
  SCHEDULED = "scheduled",
  NO_SHOW = "no_show",
  CANCELLED = "cancelled",
}

export type AttendeeResponseStatus =
  | "accepted"
  | "declined"
  | "tentative"
  | "maybe";

export interface ViewingsData {
  _id: string;
  event_created_at: string;
  event_name: string;
  viewing_type: string;
  virtual_meet_details: {
    joining_link: string;
    meeting_platform: string;
  } | null;
  physical_meet_details: {
    location: string;
  } | null;
  property_details: {
    chosen_properties: {
      property_id: number;
      property_name: string;
    }[];
    room_type: string;
  };
  scheduled_time: string;
  status: ViewingStatus;
  assignees: {
    user_name: string;
    user_role: string;
    user_id: string;
  }[];
  crm_questions_and_answers: {
    question_id: number;
    question: string;
    answer: string[];
  }[];
  cancellation_link: string | null;
  reschedule_link: string | null;
  lead_id: string;
  created_at: string;
  updated_at: string;
  attendee_response_status?: AttendeeResponseStatus | null;
  notes?: string;
}

export const StatusDisplayPriority: Record<string, number> = {
  [ViewingStatus.AWAITING_CONFIRMATION]: 0,
  [ViewingStatus.SCHEDULED]: 1,
  [ViewingStatus.COMPLETED]: 2,
  [ViewingStatus.NO_SHOW]: 3,
  [ViewingStatus.CANCELLED]: 4,
};

export type ViewingsBucket = {
  count: number;
  viewings: ViewingsData[];
};

export type FormattedViewingsData = Partial<
  Record<ViewingStatus, ViewingsBucket>
>;
